import filter from 'lodash/filter'

export const newState = (currentState, newEntry) => {
  let newState: any[] = []
  //filter out existing entry if matches newEntry
  newState = filter(currentState, (entry) => {
    return entry.pathname !== newEntry.pathname
  })
  //add new entry to beginning of array
  newState.unshift(newEntry)

  //remove last item if array exceeds limit
  newState.length > 10 ? newState.pop() : null

  return newState
}

export const setHistory = (storage, pageName, state) => {
  const stringState = JSON.stringify(state)
  try {
    storage.setItem(pageName, stringState)
  } catch (e) {
    if (e.code === 22) {
      window.alert('History is full, please clear chrome localStorage')
    }
  }
}

//PUBLIC FUNCTIONS

export const getHistory = (storage, pageName) => {
  const page = JSON.parse(storage.getItem(pageName))
  return page ? page : []
}

export const saveHistory = (storage, pageName, newEntry) => {
  //do I need to pass storage in here or can I access window wherever?
  const currentState = getHistory(storage, pageName)

  setHistory(storage, pageName, newState(currentState, newEntry))
}
